<div
  class="flex flex-col fixed bottom-0 right-0 sm:bottom-10 sm:right-10 z-50 w-full sm:w-[400px] h-4/5 sm:h-[700px] bg-light-50 rounded-2xl shadow-2xl overflow-hidden"
>
  <!-- Main body -->
  <div
    class="flex flex-col text-2xl text-light-0 items-center justify-between grow overflow-hidden"
  >
    <div class="flex flex-col grow w-full overflow-hidden">
      @switch (openPage) {

      <!-- HOME -->
      @case (ChatbotPage.HOME) {<ng-container *ngTemplateOutlet="homePage" />}

      <!-- AI_ASSISTANT -->
      <!-- @case (ChatbotPage.AI_ASSISTANT) {
      <ng-container *ngTemplateOutlet="aiAssistantPage" />
      } -->

      <!-- MESSAGES_LIST -->
      @case (ChatbotPage.MESSAGES_LIST) {
      <ng-container *ngTemplateOutlet="messagesListPage" />
      }

      <!-- FAQ -->
      @case (ChatbotPage.FAQ) {<ng-container *ngTemplateOutlet="faqPage" />}

      <!-- CHAT -->
      @case(ChatbotPage.CHAT) {
      <ng-container *ngTemplateOutlet="chatPage" />
      }
      <!--  -->
      }
    </div>

    <!-- Paginator -->
    @if(openPage !== ChatbotPage.CHAT){
    <div
      class="flex flex-row text-light-300 bg-light-0 w-full justify-between items-center cursor-pointer shadow-2xl shrink-0"
    >
      <div
        class="flex flex-col items-center px-1 py-4.5 basis-1/4 hover:text-blue-100"
        [ngClass]="{ 'text-blue-100': openPage === ChatbotPage.HOME }"
        (click)="onPageChange(ChatbotPage.HOME)"
      >
        <svg-icon src="assets/icons/home-2.svg" svgClass="h-6 w-6" />
        <span class="text-sm">Home</span>
      </div>

      <!-- Hide sia for now -->
      <!-- <div
        class="flex flex-col items-center px-1 py-4.5 basis-1/4 hover:text-blue-100 group"
        [ngClass]="{ 'text-blue-100': openPage === ChatbotPage.AI_ASSISTANT }"
        (click)="onPageChange(ChatbotPage.AI_ASSISTANT)"
      >
        <img
          src="assets/images/icons8-message-bot-48-black.png"
          class="h-7 w-7 block group-hover:hidden"
          [ngClass]="{
            '!hidden': openPage === ChatbotPage.AI_ASSISTANT
          }"
        />
        <img
          src="assets/images/icons8-message-bot-48-green.png"
          class="h-7 w-7 hidden group-hover:block"
          [ngClass]="{
            '!block': openPage === ChatbotPage.AI_ASSISTANT
          }"
        />
        <span class="text-sm">Sia</span>
      </div> -->

      <div
        class="flex flex-col items-center px-1 py-4.5 basis-1/4 hover:text-blue-100"
        [ngClass]="{ 'text-blue-100': openPage === ChatbotPage.MESSAGES_LIST }"
        (click)="onPageChange(ChatbotPage.MESSAGES_LIST)"
      >
        <svg-icon src="assets/icons/message.svg" svgClass="h-6 w-6" />
        <span class="text-sm">Messages</span>
      </div>

      <div
        class="flex flex-col items-center px-1 py-4.5 basis-1/4 hover:text-blue-100"
        [ngClass]="{ 'text-blue-100': openPage === ChatbotPage.FAQ }"
        (click)="onPageChange(ChatbotPage.FAQ)"
      >
        <svg-icon src="assets/icons/question-mark.svg" svgClass="h-6 w-6" />
        <span class="text-sm">FAQ</span>
      </div>
    </div>
    }
  </div>
</div>

<ng-template #homePage>
  <!-- Header -->
  <div class="flex flex-row items-center justify-between p-5 bg-light-300">
    <h1 class="font-bold text-lg text-light-50">Seedio's team</h1>

    <div class="cursor-pointer p-1" (click)="onChatbotClose()">
      <svg-icon src="assets/icons/close.svg" svgClass="h-3 w-3 text-light-0" />
    </div>
  </div>

  <!-- Main body -->
  <div
    class="flex flex-col gap-2 font-semibold text-3xl text-light-50 p-5 bg-light-300"
  >
    <h2>Hi {{ user?.name }}</h2>
    <h3>How can we help?</h3>
  </div>

  <div
    class="flex flex-col gap-4 grow bg-gradient-to-b from-light-300 to-light-0 p-5"
  >
    <p-card
      styleClass="group cursor-pointer"
      [style]="{ 'background-color': 'text-light-50' }"
      (click)="onPageChange(ChatbotPage.CHAT)"
    >
      <div class="flex flex-row gap-1 items-end justify-between">
        <p class="font-semibold text-sm text-light-300">
          Thinking about investing but not sure how or where?
          <span class="group-hover:text-blue-500">Sia’s here to help!</span>
        </p>

        <svg-icon
          src="assets/icons/chevron.svg"
          svgClass="h-3 w-3 text-blue-500"
        />
      </div>
    </p-card>

    <p-card
      styleClass="group cursor-pointer"
      [style]="{ 'background-color': 'text-light-50' }"
      (click)="onPageChange(ChatbotPage.CHAT)"
    >
      <div
        class="flex flex-row gap-1 items-center justify-between cursor-pointer"
      >
        <p
          class="font-semibold text-sm text-light-300 group-hover:text-blue-500"
        >
          Send us a message
        </p>

        <svg-icon
          src="assets/icons/submit.svg"
          svgClass="h-3 w-3 text-blue-500"
        />
      </div>
    </p-card>

    <p-card
      styleClass="group cursor-pointer"
      [style]="{ 'background-color': 'text-light-50' }"
      (click)="onPageChange(ChatbotPage.FAQ)"
    >
      <div class="flex flex-row gap-1 items-end justify-between cursor-pointer">
        <p class="font-semibold text-sm text-light-300">
          Check <span class="group-hover:text-blue-500">FAQs</span> for quick
          answers to common questions.
        </p>

        <svg-icon
          src="assets/icons/magnifier.svg"
          svgClass="h-3 w-3 text-blue-500"
        />
      </div>
    </p-card>
  </div>
</ng-template>

<ng-template #aiAssistantPage> aiAssistantPage </ng-template>

<ng-template #messagesListPage>
  <!-- Header -->
  <div
    class="flex flex-row items-center justify-between p-5 border-b border-light-120"
  >
    @if (messagePagesHistory.length === 1) {
    <div class="p-3"></div>
    } @else {
    <div
      class="cursor-pointer p-1 rotate-180 rounded-lg hover:bg-light-120"
      (click)="onMessagePreviousPageClick()"
    >
      <svg-icon
        src="assets/icons/chevron.svg"
        svgClass="h-4 w-4 text-light-300"
      />
    </div>
    }

    <h1 class="font-bold text-lg text-light-300">Messages</h1>

    <div
      class="cursor-pointer p-2 rounded-lg hover:bg-light-120"
      (click)="onChatbotClose()"
    >
      <svg-icon
        src="assets/icons/close.svg"
        svgClass="h-3 w-3 text-light-300"
      />
    </div>
  </div>

  <!-- Main body -->
  <div class="flex flex-col justify-between grow overflow-hidden">
    @if(_chatbotService.isConversationsLoading$ | async){
    <app-loading-spinner />
    } @else {

    <ul class="flex flex-col grow overflow-auto">
      @for (item of conversations; track $index) {
      <li
        class="flex flex-row items-center justify-between py-4 px-5 text-light-300 hover:bg-blue-600 cursor-pointer group"
        (click)="onConversationClick(item)"
      >
        <div class="flex flex-col gap-1">
          <header class="font-normal text-sm text-light-300">
            @if (item.messages[item.messages.length - 1]) {
            {{ item.messages[item.messages.length - 1].content }}
            }
          </header>
          <p class="font-normal text-sm text-light-400">
            Seedio: {{ item.timestamp | date : "d MMMM" }}
          </p>
        </div>

        <svg-icon
          src="assets/icons/chevron.svg"
          svgClass="h-2.5 w-2.5 text-blue-500"
        />
      </li>
      <div class="mx-5 border-b border-light-120"></div>
      }
    </ul>

    }
  </div>
</ng-template>

<ng-template #faqPage>
  <!-- Header -->
  <div
    class="flex flex-row items-center justify-between p-5 border-b border-light-120"
  >
    @if (faqPagesHistory.length === 0) {
    <div class="p-3"></div>
    } @else {
    <div
      class="cursor-pointer p-1 rotate-180 rounded-lg hover:bg-light-120"
      (click)="onFAQPreviousPageClick()"
    >
      <svg-icon
        src="assets/icons/chevron.svg"
        svgClass="h-4 w-4 text-light-300"
      />
    </div>
    }

    <h1 class="font-bold text-lg text-light-300">FAQ</h1>

    <div
      class="cursor-pointer p-2 rounded-lg hover:bg-light-120"
      (click)="onChatbotClose()"
    >
      <svg-icon
        src="assets/icons/close.svg"
        svgClass="h-3 w-3 text-light-300"
      />
    </div>
  </div>

  <div class="grow overflow-auto">
    <!-- Main body -->
    @switch (faqOpenPage) {
    <!-- COLLECTIONS -->
    @case (FAQPage.COLLECTIONS) {
    <ng-container *ngTemplateOutlet="FAQpage1collections" />
    }
    <!-- GROUPS_OF_ARTICLES_LISTS -->
    @case (FAQPage.GROUPS_OF_ARTICLES_LISTS) {
    <ng-container *ngTemplateOutlet="FAQpage2groupsOfArticleLists" />
    }
    <!-- ARTICLE_LISTS -->
    @case (FAQPage.ARTICLES_LIST) {
    <ng-container *ngTemplateOutlet="FAQpage3articleList" />
    }
    <!-- READ_ARTICLE -->
    @case (FAQPage.READ_ARTICLE) {
    <ng-container *ngTemplateOutlet="FAQpage4readArticle" />
    }
    <!--  -->
    }
  </div>
</ng-template>

<ng-template #FAQpage1collections>
  <div class="flex flex-col gap-2">
    <ul>
      @for (item of faqCollections; track $index) {
      <li
        class="flex flex-row items-center justify-between py-4 px-5 text-light-300 hover:bg-blue-600 cursor-pointer group"
        (click)="onFAQCollectionClick(item)"
      >
        <div class="flex flex-col gap-1">
          <header
            class="font-semibold text-sm text-light-300 group-hover:text-blue-500"
          >
            {{ item.name }}
          </header>
          <p class="font-normal text-sm text-light-200">
            {{ item.description }}
          </p>
          <p class="font-normal text-sm text-light-60">
            {{ item.numberOfArticles }}

            {{ item.numberOfArticles > 1 ? "articles" : "article" }}
          </p>
        </div>

        <svg-icon
          src="assets/icons/chevron.svg"
          svgClass="h-2.5 w-2.5 text-blue-500"
        />
      </li>
      <div class="mx-5 border-b border-light-120"></div>
      }
    </ul>
  </div>
</ng-template>

<ng-template #FAQpage2groupsOfArticleLists>
  <div class="flex flex-col">
    <div class="flex flex-col gap-1 py-4 px-5 text-light-300">
      <header class="font-semibold text-base text-light-300 mb-3">
        {{ faqPage2LoadedCollection?.name }}
      </header>
      <p class="font-normal text-sm text-light-200">
        {{ faqPage2LoadedCollection?.description }}
      </p>
      <p class="font-normal text-sm text-light-60">
        {{ faqPage2LoadedCollection?.numberOfArticles }}

        {{
          (faqPage2LoadedCollection?.numberOfArticles || 0) > 1
            ? "articles"
            : "article"
        }}
      </p>
    </div>

    <div class="border-b border-light-120"></div>

    <ul>
      @for (item of faqPage2LoadedCollection?.articleCollections; track $index)
      {
      <li
        class="flex flex-row items-center justify-between py-4 px-5 text-light-300 hover:bg-blue-600 cursor-pointer group"
        (click)="onFAQArticleCollectionClick(item)"
      >
        <div class="flex flex-col gap-1">
          <header
            class="font-semibold text-sm text-light-300 group-hover:text-blue-500"
          >
            {{ item.name }}
          </header>
          <p class="font-normal text-sm text-light-200">
            {{ item.description }}
          </p>
          <p class="font-normal text-sm text-light-60">
            {{ item.articles.length }}

            {{ item.articles.length > 1 ? "articles" : "article" }}
          </p>
        </div>

        <svg-icon
          src="assets/icons/chevron.svg"
          svgClass="h-2.5 w-2.5 text-blue-500"
        />
      </li>
      <div class="mx-5 border-b border-light-120"></div>
      }
    </ul>
  </div>
</ng-template>

<ng-template #FAQpage3articleList>
  <div class="flex flex-col">
    <div class="flex flex-col gap-1 py-4 px-5 text-light-300">
      <header class="font-semibold text-base text-light-300 mb-3">
        {{ faqPage3LoadedArticleCollection?.name }}
      </header>
      <p class="font-normal text-sm text-light-200">
        {{ faqPage3LoadedArticleCollection?.description }}
      </p>
      <p class="font-normal text-sm text-light-60">
        {{ faqPage3LoadedArticleCollection?.articles?.length }}

        {{
          (faqPage3LoadedArticleCollection?.articles?.length || 0) > 1
            ? "articles"
            : "article"
        }}
      </p>
    </div>

    <div class="border-b border-light-120"></div>

    <ul>
      @for (item of faqPage3LoadedArticleCollection?.articles; track $index) {
      <li
        class="flex flex-row items-center justify-between py-4 px-5 text-light-300 hover:bg-blue-600 cursor-pointer group"
        (click)="onFAQArticleClick(item)"
      >
        <div class="flex flex-col gap-1">
          <header
            class="font-normal text-sm text-light-300 group-hover:text-blue-500"
          >
            {{ item.title }}
          </header>
        </div>

        <svg-icon
          src="assets/icons/chevron.svg"
          svgClass="h-2.5 w-2.5 text-blue-500"
        />
      </li>
      <div class="mx-5 border-b border-light-120"></div>
      }
    </ul>
  </div>
</ng-template>

<ng-template #FAQpage4readArticle>
  <div class="flex flex-col grow scroll-auto">
    <p [innerHTML]="faqPage4LoadedArticle?.contentHTML"></p>
  </div>
</ng-template>

<ng-template #chatPage>
  <!-- Header -->
  <div
    class="flex flex-row items-center justify-between p-5 border-b border-light-120"
  >
    @if (messagePagesHistory.length === 0) {
    <div class="p-3"></div>
    } @else {
    <div
      class="cursor-pointer p-1 rotate-180 rounded-lg hover:bg-light-120"
      (click)="onMessagePreviousPageClick()"
    >
      <svg-icon
        src="assets/icons/chevron.svg"
        svgClass="h-4 w-4 text-light-300"
      />
    </div>
    }

    <h1 class="font-bold text-lg text-light-300">Seedio</h1>

    <div
      class="cursor-pointer p-2 rounded-lg hover:bg-light-120"
      (click)="onChatbotClose()"
    >
      <svg-icon
        src="assets/icons/close.svg"
        svgClass="h-3 w-3 text-light-300"
      />
    </div>
  </div>

  <!-- Main body -->
  <div class="flex flex-col justify-between grow overflow-hidden">
    <div #scrollContainer class="flex flex-col grow overflow-auto gap-1 p-5">
      <p class="font-normal text-sm text-light-60 text-center pb-4">
        Ask us anything, or share your feedback.
      </p>

      @for (item of currentConversation?.messages; track $index) {

      <!--  -->
      @if (item.sender === MessageSender.USER) {
      <div
        class="flex flex-row justify-end font-normal text-sm text-light-0"
        [ngClass]="{
          'pb-4': !$last && currentConversation!.messages[$index + 1].sender !==
          MessageSender.USER,
        }"
      >
        <p class="w-fit rounded-2xl py-3 px-4 bg-blue-500">
          {{ item.content }}
        </p>
      </div>

      } @else {

      <div
        class="flex flex-row justify-start font-normal text-sm text-light-300"
        [ngClass]="{
          'pb-4':
            !$last &&
            currentConversation!.messages[$index + 1].sender !==
              MessageSender.AI_ASSISTANT &&
            currentConversation!.messages[$index + 1].sender !==
              MessageSender.CUSTOMER_SUPPORT
        }"
      >
        <div class="flex flex-col gap-1 w-fit rounded-2xl py-3 px-4 bg-light-0">
          <h1 class="font-semibold text-xs text-light-300">Seedio</h1>
          <p>
            {{ item.content }}
          </p>
        </div>
      </div>

      }
      <!--  -->
      }

      <!-- Loading dots -->
      @if (_chatbotService.isMessageLoading$ |async) {
      <div
        class="flex flex-row justify-start font-normal text-sm text-light-300"
      >
        <div
          class="flex flex-col gap-1 w-fit rounded-2xl py-2 px-10 bg-light-0"
        >
          <img src="assets/gifs/icons8-loading.gif" class="h-5 w-5" />
        </div>
      </div>
      }
    </div>

    @if(currentConversation?.hasCompleted){
    <div class="shrink-0 w-full px-5 pb-2 border-t border-light-120">
      <p class="font-normal text-sm text-light-60 text-center pt-6 pb-3">
        Your conversation has ended
      </p>
    </div>
    } @else {
    <div class="flex gap-2 items-center shrink-0 w-full px-5 pb-2">
      <textarea
        pTextarea
        [(ngModel)]="message"
        placeholder="Message..."
        rows="1"
        class="shadow-2xl"
        styleClass="shadow-2xl"
        (keydown.enter)="sendMessage($event)"
        autoResize="true"
        fluid="true"
      ></textarea>

      <img
        src="assets/images/send-96.png"
        class="h-8 w-8 cursor-pointer"
        alt="send"
        (click)="sendMessage($event)"
      />
    </div>
    }
  </div>
</ng-template>
